export default __webpack_public_path__ + "static/media/bishallogo.df07a4eb.png";